import { type ApiResult, type BaseParams, type PostParams } from '@pkg/types/api';
import {
    type CreateOrganization,
    type OrganizationBranding,
    type OrganizationBrandingResponse,
    type OrganizationKey,
    type OrganizationResponse,
} from '@pkg/types/app/organizations.ts';

import { getRequest, postRequest, putRequest } from '@app/client/common/api';
import { links } from '@app/client/links/links.ts';

export async function createOrganization(
    params: BaseParams & PostParams<CreateOrganization>,
): Promise<ApiResult<OrganizationResponse>> {
    return postRequest<OrganizationResponse>({
        ...params,
        target: links.organizations().collection(),
    });
}

export async function addBranding(
    params: BaseParams & PostParams<OrganizationBranding> & { key: OrganizationKey },
): Promise<ApiResult<OrganizationBrandingResponse>> {
    return putRequest<OrganizationBrandingResponse>({
        ...params,
        target: links.organizations().branding(params.key),
    });
}

export async function getBranding(
    params: BaseParams & { key: OrganizationKey },
): Promise<ApiResult<OrganizationBrandingResponse>> {
    return getRequest<OrganizationBrandingResponse>({
        ...params,
        target: links.organizations().branding(params.key),
    });
}
